import { fetchApi } from "../../utils/api";

export async function getProfileCompany(payload) {
    try {
        let response = await fetchApi(`/app/profile_company/get-profile-company`, 'get', payload);

        if (response.code !== 200) {
            return {
                data: {},
            };
        }
        return response.data;
    } catch (error) {
        console.log(error);
        return {

        };
    }
}